module.exports = __webpack_public_path__ + "static/media/footer.5ee84717.svg";